export default __webpack_public_path__ + "static/Norway-grants-21c2d4dde27dcf6d9769c60859bdb7a7.png";